// extracted by mini-css-extract-plugin
module.exports = {"label":"_2zwjhOTkrOMdhTvwtvkOid","value":"_2zR4varFq_rV6KHkIhwwc2"};